module.exports = __webpack_public_path__ + "static/img/punball_small_8.ce2b8da.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/zh-CN/punball_small_8.jpg
// module id = iZzQ
// module chunks = 0